import { useQuery } from '@tanstack/react-query';
import { getGroupSettlement } from './api';

const groupSettlementKeys = {
    all: ['groupSettlement'] as const,
    detail: (centerId: string, year: number, month: number) =>
        [...groupSettlementKeys.all, centerId, year, month] as const,
};

export const useGroupSettlement = ({
    centerId,
    year,
    month,
    enabled = true,
}: {
    centerId: string;
    year: number;
    month: number;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: groupSettlementKeys.detail(centerId, year, month),
        queryFn: () => getGroupSettlement({ centerId, year, month }),
        enabled: enabled && !!centerId,
        select: (data) => data?.data,
    });
